module.exports = __webpack_public_path__ + "img/background.0503eb5e.jpg";